import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Table,
  Button,
  Row,
  Col,
  ButtonGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import Baja from "../../Baja";
import { v4 as uuidv4 } from "uuid";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

function EntradaProcesosCreate() {
  const { user } = useContext(AuthContext);
  const URL_PROCESOS_SALIDA = process.env.REACT_APP_URL_PROCESOS_SALIDA;
  const URL_ARTICULOS_PROCESOS_SALIDA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_SALIDA;
  const URL_ARTICULOS_PROCESOS_ENTRADA = process.env.REACT_APP_URL_ARTICULOS_PROCESOS_ENTRADA;
  const URL_PROCESOS_ENTRADA = process.env.REACT_APP_URL_PROCESOS_ENTRADA;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_DETALLE_HABILITACION_CORTES = process.env.REACT_APP_URL_DETALLE_HABILITACION_CORTES;
  const URL_HABILITACION_CORTES = process.env.REACT_APP_URL_HABILITACION_CORTES;
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  let hoy = new Date();
  let endDate = moment(hoy).format("YYYY-MM-DD");

  const [procesos, setProcesos] = useState([]);
  const [selectedProceso, setSelectedProceso] = useState("");
  const [fecha, setFecha] = useState(endDate);
  const [articulosProcesosEntrada, setArticulosProcesosEntrada] = useState([]);
  const [maquileroProceso, setMaquileroProceso] = useState("");
  const [nombreMaquileroProceso, setNombreMaquileroProceso] = useState("");
  const [precioProceso, setPrecioProceso] = useState(0);
  const [totalPiezas, setTotalPiezas] = useState(0);
  const [totalGeneral, setTotalGeneral] = useState(0);
  const [selectedProcesoSalida, setSelectedProcesoSalida] = useState("");
  const [idCatalogoProcesos, setIdCatalogoProcesos] = useState("");
  const [nombreProcesosEntrada, setNombreProcesosEntrada] = useState("");
  const [idArticulo, setIdArticulo] = useState("");
  const [nombreArticulo, setNombreArticulo] = useState("");
  const [idPedido, setIdPedido] = useState("");
  const [numeroPedido, setNumeroPedido] = useState("");
  const [numeroOP, setNumeroOP] = useState("");
  const [validaBoton, setValidaBoton] = useState(true);
  const [idCorte, setIdCorte] = useState(true);
  const [observaciones, setObservaciones] = useState("NA");
  const [habilitacionProceso, setHabilitacionProceso] = useState([]);
  const [porcentajeGlobal, setPorcentajeGlobal] = useState(0);
  const [totalHabilitacion, setTotalHabilitacion] = useState(0);
    const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());
const [idHabilitacionCorte, setIdHabilitacionCorte] = useState("");
const [saldoHabilitacionCorte, setSaldoHabilitacionCorte] = useState(0);
const [aplicarPago, setAplicarPago] = useState(true); // true por default si quieres

  const [selectedOrden, setSelectedOrden] = useState("");
  const [selectedOrdenObj, setSelectedOrdenObj] = useState(null);

  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      colores: "",
      tallas: "",
      cantidad: 0,
      total: 0,
      articulosPedido: "",
    },
  ]);


    const [modalProgreso, setModalProgreso] = useState(false);
    const toggleProgreso = () => setModalProgreso(!modalProgreso);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(
        `${URL_PROCESOS_SALIDA}Activos`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        let allProcesos = response.data;
        let arrayTabla = allProcesos
          .sort((a, b) => (a.fechaCompromiso > b.fechaCompromiso ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              status: a.status,
              fecha: a.fecha,
              fechaCompromiso: a.fechaCompromiso,
              maquilero: a.proveedores[0].nombre_comercial,
              idMaquilero: a.proveedores[0]._id,
              idPedido: a.pedidos[0]._id,
              numeroPedido: a.pedidos[0].pedidoCliente,
              nombreProcesosEntrada: a.catalogoProcesos[0].name,
              idCatalogoProcesos: a.catalogoProcesos[0]._id,
              corte: a.cortes[0].idCorte,
              idCorte: a.cortes[0]._id,
              cantidad: a.totalPiezas,
              nombreArticulo: a.articulos[0].articulosPadre[0].codigo + " / " + a.articulos[0].articulosPadre[0].codigoCliente + " / " + a.articulos[0].nombre,
              idArticulo: a.articulos[0]._id,
              numeroOP: a.cortes[0].ordenesCorte[0].numeroOP,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
        setProcesos(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user]);

function jalaOrden(idSeleccionado) {
  setInputFields([])
  setHabilitacionProceso([])
  const selectedProceso = procesos.find((p) => p._id === idSeleccionado._id);
  if (!selectedProceso) return;

  const {
    idCatalogoProcesos,
    catalogoProcesos,
    idArticulo,
    nombreArticulo,
    idPedido,
    numeroPedido,
    _id,
    numeroOP,
    idCorte
  } = selectedProceso;

  axios
    .get(`${URL_ARTICULOS_PROCESOS_SALIDA}/proceso/${idSeleccionado._id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allArticulosProcesosEntrada = response.data;
      setArticulosProcesosEntrada(allArticulosProcesosEntrada);
      setMaquileroProceso(
        allArticulosProcesosEntrada[0].procesosSalida[0].proveedores[0]._id
      );
      setNombreMaquileroProceso(
        allArticulosProcesosEntrada[0].procesosSalida[0].proveedores[0].nombre_comercial
      );
      setPrecioProceso(
        allArticulosProcesosEntrada[0].procesosSalida[0].precio
      );

      let arrayInputFields = allArticulosProcesosEntrada.map((a) => {
        return {
          id: uuidv4(),
          colores: a.articulosPedido[0].colores[0].name,
          tallas: a.articulosPedido[0].tallas[0].name,
          cantidad: 0,
          cantidadSalida: a.cantidadSalida,
          cantidadEntrada: a.cantidadEntrada,
          total: 0,
          articulosPedido: a.articulosPedido[0]._id,
          articulosProcesosSalida: a._id,
        };
      });

      let dataIF = Object.values(arrayInputFields);
      setInputFields(dataIF);

      let cantTotal = dataIF.map((c) => parseFloat(c.cantidad));
      let TC = cantTotal.reduce((t, total) => t + total, 0);
      setTotalPiezas(TC);

      let impTotal = dataIF.map((c) => parseFloat(c.total));
      let TG = impTotal.reduce((t, total) => t + total, 0);
      setTotalGeneral(TG);
    })
    .catch((err) => {
      console.log(err);
    });

  setSelectedProcesoSalida(_id);
  setIdCatalogoProcesos(idCatalogoProcesos);
  setNombreProcesosEntrada(catalogoProcesos);
  setIdArticulo(idArticulo);
  setNombreArticulo(nombreArticulo);
  setIdPedido(idPedido);
  setNumeroPedido(numeroPedido);
  setNumeroOP(numeroOP);
  setIdCorte(idCorte);

  axios
  .get(`${URL_DETALLE_HABILITACION_CORTES}/proceso/${idSeleccionado._id}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allHabilitacionProceso = response.data;
    let arrayTabla = allHabilitacionProceso
      .map((a) => {
        if (a.precio > 0) {
          return {
            id: a._id,
            habilitacion:
              a.habilitacion[0].nombre + " " + a.habilitacion[0].descripcion,
            cantidad: a.cantidad,
            precio: a.precio,
            habilitacionCortes: a.habilitacionCortes[0]._id,
            saldoHabilitacion: a.habilitacionCortes[0].saldo,
          };
        }
        return null;
      })
      .filter((el) => el !== null);

    const dataFinal = Object.values(arrayTabla);
    setHabilitacionProceso(dataFinal);

    // Guardar el primer habilitacionCortes si existe
    if (dataFinal.length > 0 && dataFinal[0].habilitacionCortes) {
      setIdHabilitacionCorte(dataFinal[0].habilitacionCortes);
      setSaldoHabilitacionCorte(dataFinal[0].saldoHabilitacion);
    } else {
      setIdHabilitacionCorte("");
      setSaldoHabilitacionCorte(0);
    }
    // Sin saldo de habilitación (material ya descontado) no hay nada que aplicar
    const saldoHab = dataFinal.length > 0 ? Number(dataFinal[0].saldoHabilitacion) || 0 : 0;
    setAplicarPago(saldoHab > 0.005);

    // Calcular el total cantidad * precio
    const total = dataFinal.reduce(
      (sum, item) => sum + item.cantidad * item.precio,
      0
    );
    setTotalHabilitacion(total);
  })
  .catch((err) => {
    console.log(err);
  });


}

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = parseFloat(event.target.value);
        i.total = parseFloat(event.target.value) * parseFloat(precioProceso);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };
  function ActualizaTotales() {
    let cantTotal = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cantTotal.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TC);

    let impTotal = inputFields.map((c) => parseFloat(c.total));
    let TG = impTotal.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);

      const totalCantidad = inputFields.reduce((acc, cur) => acc + Number(cur.cantidad), 0);
const totalCantidadSalida = inputFields.reduce((acc, cur) => acc + Number(cur.cantidadSalida), 0);
setPorcentajeGlobal(totalCantidadSalida > 0 ? (totalCantidad / totalCantidadSalida) * 100 : 0)
  }

  //   const saveEntradaProceso = async (event) => {
  //   event.preventDefault();
  //   if (fecha != "") {
  //     setValidaBoton(false);
  //     toggleProgreso();

  //     let totalRollos = inputFields.length;
  //     try {
  //       await axios
  //         .post(
  //           URL_PROCESOS_ENTRADA,
  //           {
  //             catalogoProcesos: idCatalogoProcesos,
  //             proveedores: maquileroProceso,
  //             pedidos: idPedido,
  //             fecha,
  //             observaciones,
  //             totalGeneral,
  //             totalPiezas,
  //             precio: precioProceso,
  //             cortes: idCorte,
  //             procesosSalida: selectedProcesoSalida,
  //           },
  //           {
  //             headers: {
  //               Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //             },
  //           }
  //         )
  //         .then((data) => {
  //           axios.post(
  //             URL_NOTAS_CXP,
  //             {
  //               procesosEntrada: data.data._id,
  //               proveedores: maquileroProceso,
  //               total_cantidad: totalPiezas,
  //               total_costo: totalGeneral,
  //               saldo: totalGeneral,
  //               fecha: fecha
  //             },
  //             {
  //               headers: {
  //                 Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //               },
  //             }
  //           );

  //           inputFields.map((a) => {
  //             if (a.cantidad != 0) {
  //               axios
  //                 .post(
  //                   URL_ARTICULOS_PROCESOS_ENTRADA,
  //                   {
  //                     procesosEntrada: data.data._id,
  //                     articulosPedido: a.articulosPedido,
  //                     articulosProcesosSalida: a.articulosProcesosSalida,
  //                     pedidos: idPedido,
  //                     cantidadEntrada: a.cantidad,
  //                     cortes: idCorte,
  //                     procesosSalida: selectedProcesoSalida,
  //                   },
  //                   {
  //                     headers: {
  //                       Authorization: `Bearer: ${localStorage.getItem(
  //                         "app_token"
  //                       )}`,
  //                     },
  //                   }
  //                 )
  //                 .then(() => {
  //                   totalRollos = totalRollos - 1;
  //                   if (totalRollos == 0) {
  //                     axios
  //                       .post(
  //                         URL_LOGS,
  //                         {
  //                           tipo: "Entrada de Proceso",
  //                           detalle: `Pedido ${numeroPedido}`,
  //                           user: user.id,
  //                         },
  //                         {
  //                           headers: {
  //                             Authorization: `Bearer: ${localStorage.getItem(
  //                               "app_token"
  //                             )}`,
  //                           },
  //                         }
  //                       )
  //                       .then(() => {
  //                         Swal.fire("Good job!", "Creado con exito", "success");
  //                         setTimeout(() => {
  //                           window.location.reload();
  //                         }, 1000);
  //                       })
  //                       .catch((error) => {
  //                         Swal.fire({
  //                           icon: "error",
  //                           title: "Oops...",
  //                           text: "Something went wrong!",
  //                           footer: `${error.response.data}`,
  //                         });
  //                         console.log(error);
  //                         setValidaBoton(true);
  //                       });
  //                   }
  //                 });
  //             } else {
  //               totalRollos = totalRollos - 1;
  //               if (totalRollos == 0) {
  //                 axios
  //                   .post(
  //                     URL_LOGS,
  //                     {
  //                       tipo: "Entrada de Proceso",
  //                       detalle: `Pedido ${numeroPedido}`,
  //                       user: user.id,
  //                     },
  //                     {
  //                       headers: {
  //                         Authorization: `Bearer: ${localStorage.getItem(
  //                           "app_token"
  //                         )}`,
  //                       },
  //                     }
  //                   )
  //                   .then(() => {
  //                     Swal.fire("Good job!", "Creado con exito", "success");
  //                     setTimeout(() => {
  //                       window.location.reload();
  //                     }, 1000);
  //                   })
  //                   .catch((error) => {
  //                     Swal.fire({
  //                       icon: "error",
  //                       title: "Oops...",
  //                       text: "Something went wrong!",
  //                       footer: `${error.response.data}`,
  //                     });
  //                     console.log(error);
  //                     setValidaBoton(true);
  //                   });
  //               }
  //             }
  //           });
  //         });
  //     } catch (error) {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //         footer: `${error.response.data}`,
  //       });
  //       console.log(error);
  //     }
  //   } else {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Something went wrong!",
  //       footer: `Faltan Datos`,
  //     });
  //   }
  // };

  const saveEntradaProceso = async (event) => {
  event.preventDefault();
  if (aplicarPago && (saldoHabilitacionCorte < (totalHabilitacion * (porcentajeGlobal / 100)))) {
    Swal.fire({
      icon: "error",
      title: "Saldo insuficiente",
      text: `El saldo de habilitación (${saldoHabilitacionCorte.toFixed(2)}) es menor al monto a aplicar.`,
    });
    return; // ❌ no continuar
  }else{

  if (fecha !== "") {
    setValidaBoton(false);
    toggleProgreso();

    let totalRollos = inputFields.length;
    try {
      // 1. Guardar Entrada de Proceso
      const entradaRes = await axios.post(
        URL_PROCESOS_ENTRADA,
        {
          catalogoProcesos: idCatalogoProcesos,
          proveedores: maquileroProceso,
          pedidos: idPedido,
          fecha,
          observaciones,
          totalGeneral,
          totalPiezas,
          precio: precioProceso,
          cortes: idCorte,
          procesosSalida: selectedProcesoSalida,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      const entradaId = entradaRes.data._id;

      // 2. Crear notaCxP
      const notaRes = await axios.post(
        URL_NOTAS_CXP,
        {
          procesosEntrada: entradaId,
          proveedores: maquileroProceso,
          total_cantidad: totalPiezas,
          total_costo: totalGeneral,
          saldo: totalGeneral,
          fecha: fecha,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      const notaId = notaRes.data._id;

      // 3. Guardar artículos
      for (const a of inputFields) {
        if (a.cantidad !== 0) {
          await axios.post(
            URL_ARTICULOS_PROCESOS_ENTRADA,
            {
              procesosEntrada: entradaId,
              articulosPedido: a.articulosPedido,
              articulosProcesosSalida: a.articulosProcesosSalida,
              pedidos: idPedido,
              cantidadEntrada: a.cantidad,
              cortes: idCorte,
              procesosSalida: selectedProcesoSalida,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
        }
      }

      // 4. Calcular monto a aplicar (porcentaje)
      // const porcentajeGlobal = 65; // Puedes calcularlo dinámicamente si lo necesitas
      const montoAplicar = (totalHabilitacion * porcentajeGlobal) / 100;

      if (aplicarPago) {
     // 5. Crear abono
await axios.post(`${URL_ABONOS_PROVEEDORES}`, {
  fecha,
  importe: montoAplicar,
  proveedores: maquileroProceso,
  notasCxP: notaId,
  observaciones: `Abono automático del ${porcentajeGlobal}%`,
  codigoAgrupado: "NA",
  editado: "No",
  habilitacionCortes: idCorte,
  concepto: "Habilitación Aplicada",
  formaPago: "Material"
}, {
  headers: {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  },
});

// 6. Actualizar saldo de la notaCxP
await axios.patch(`${URL_NOTAS_CXP}/${notaId}`, {
  saldo: totalGeneral - montoAplicar,
}, {
  headers: {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  },
});

// 6.1. Aplicar saldo a la habilitación de cortes
await axios.patch(`${URL_HABILITACION_CORTES}AplicarSaldo/${idHabilitacionCorte}`, {
  saldo: montoAplicar,
}, {
  headers: {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  },
});
      }

      // 7. Crear log
      await axios.post(
        URL_LOGS,
        {
          tipo: "Entrada de Proceso",
          detalle: `Pedido ${numeroPedido} con abono automático`,
          user: user.id,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );

      // 8. Éxito
      Swal.fire("Listo", "Creado exitosamente", "success");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Algo salió mal",
        footer: error?.response?.data || "Error inesperado",
      });
      setValidaBoton(true);
    }
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Faltan datos obligatorios",
    });
  }
}
};

    const options = procesos.map((option) => {
    const junta = option.numeroOP + " " + option.maquilero;
    const firstLetter = option.numeroOP[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });




  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_produccion ? (
        <div className="row">
          <div className="col-md-12">
            <div className="card style={{ width: 'auto' }}">
              <div className="card-body">
                <Row>
                  <Col md={7}>
                    <Button
                      size="sm"
                      href="/MenuProduccion"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                </Row>
                <br />
                <h3 align="center">Entrada Procesos</h3>
                <Row>
                  <Col md={2}>
                    <Label>Fecha</Label>
                    <Input
                      // bsSize="sm"
                      type="date"
                      value={fecha}
                      onChange={(e) => {
                        setFecha(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={2}>
                    <Label className="mr-sm-2">Proceso Salida</Label>
                    {/* <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedOrden}
                      required
                      onChange={(e) => jalaOrden(e.target.value)}
                    >
                      <option value="0">Selecciona un Proceso</option>
                      {procesos
                        .sort((a, b) => (a.numeroOP < b.numeroOP ? 1 : -1))
                        .map((a) => (
                          <option key={a._id} value={a._id}>
                            OP # {a.numeroOP}
                          </option>
                        ))}
                    </Input> */}
                    <Autocomplete
                      size="small"
                      value={numeroOP}
                      onChange={(event, selectedOrden) => {
                        if (selectedOrden) {
                          jalaOrden(selectedOrden);
                          // setSelectedCliente(selectedCliente._id);
                          // setSelectedClienteNombre(
                          //   selectedCliente.nombre_comercial
                          // );
                        }
                      }}
                      options={options.sort(
                        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                      )}
                      groupBy={(option) => option.firstLetter}
                      getOptionLabel={(option) => option.junta}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona"
                          variant="outlined"
                        />
                      )}
                      renderOption={(option) => (
                        <React.Fragment>
                          {option.numeroOP} {option.maquilero}
                        </React.Fragment>
                      )}
                    />
                  </Col>
                  <Col md={1}>
                    <Label>Numero OP</Label>
                    <Input
                      // bsSize="sm"
                      type="string"
                      value={numeroOP}
                      disabled
                    />
                  </Col>
                  <Col md={3}>
                    <Label>Articulo</Label>
                    <Input
                      // bsSize="sm"
                      type="string"
                      value={nombreArticulo}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Maquilero</Label>
                    <Input
                      // bsSize="sm"
                      type="string"
                      value={nombreMaquileroProceso}
                      disabled
                    />
                  </Col>
                  <Col md={2}>
                    <Label>Precio</Label>
                    <Input
                      // bsSize="sm"
                      type="string"
                      value={precioProceso}
                      disabled
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Observaciones
                    </Label>
                    <Input
                      type="textarea"
                      placeholder="Observaciones"
                      value={observaciones}
                      required
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                {/* Tabla Articulos */}
                <br />
                <Row className="justify-content-center">
                  <Col md={10}>
                    <Row>
                      <Col md={2}>
                        <Label className="mr-sm-2">Color</Label>
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Talla</Label>
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Cantidad Salida</Label>
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Cantidad Entrada</Label>
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Cantidad</Label>
                      </Col>
                      <Col md={2}>
                        <Label className="mr-sm-2">Total</Label>
                      </Col>
                    </Row>
                    {inputFields
                      .sort((a, b) => {
                        // Convertir las tallas de cadena a número antes de comparar
                        const tallasA = parseInt(a.tallas);
                        const tallasB = parseInt(b.tallas);

                        // Ordenar primero por 'colores' y luego por 'tallas'
                        return (
                          a.colores.localeCompare(b.colores) ||
                          tallasA - tallasB
                        );
                      })
                      .map((inputField) => (
                        <div key={inputField.id}>
                          <Row>
                            <Col md={2}>
                              <Input
                                bsSize="sm"
                                name="color"
                                type="text"
                                value={inputField.colores}
                                disabled
                              />
                            </Col>
                            <Col md={2}>
                              <Input
                                bsSize="sm"
                                name="talla"
                                type="text"
                                value={inputField.tallas}
                                disabled
                              />
                            </Col>
                            <Col md={2}>
                              <Input
                                bsSize="sm"
                                name="talla"
                                type="text"
                                value={inputField.cantidadSalida}
                                disabled
                              />
                            </Col>
                            <Col md={2}>
                              <Input
                                bsSize="sm"
                                name="talla"
                                type="text"
                                value={inputField.cantidadEntrada}
                                disabled
                              />
                            </Col>
                            <Col md={2}>
                              <Input
                                bsSize="sm"
                                name="cantidad"
                                type="number"
                                value={inputField.cantidad}
                                onChange={(event) =>
                                  handleChangeInputCantidad(
                                    inputField.id,
                                    event
                                  )
                                }
                              />
                            </Col>
                            <Col md={2}>
                              <Input
                                bsSize="sm"
                                name="total"
                                type="number"
                                value={inputField.total}
                                disabled
                              />
                            </Col>
                          </Row>
                        </div>
                      ))}
                    <br />
                    <Row>
                      <Col md={4}></Col>
                      <Col md={4}>
                        <h4>TOTALES</h4>
                      </Col>
                      <Col md={2}>
                        <h4>{totalPiezas}</h4>
                      </Col>
                      <Col md={2}>
                        <h4>
                          {"$" +
                            new Intl.NumberFormat("en-US").format(totalGeneral)}
                        </h4>
                      </Col>
                    </Row>
                    <br />
                    <Row>
  <Col md={{ size: 4, offset: 8 }}>
    <h6>
      Porcentaje Entrada: {porcentajeGlobal.toFixed(2)}%
    </h6>
  </Col>
</Row>


                    <br />
                    <h4>Habilitacion</h4>
<Table bordered responsive size="sm">
  <thead className="thead-light">
    <tr>
      <th>Material</th>
      <th>Cantidad</th>
      <th>Precio</th>
      <th>Total</th>
    </tr>
  </thead>
  <tbody>
    {habilitacionProceso.map((a, index) => (
      <tr key={index}>
        <td>{a.habilitacion}</td>
        <td>{a.cantidad}</td>
        <td>
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precio)}
        </td>
        <td>
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format((a.precio * a.cantidad).toFixed(2))}
        </td>
      </tr>
    ))}

    {/* Totales */}
    <tr className="negrita">
      <td>Totales:</td>
      <td>{habilitacionProceso.reduce((sum, a) => sum + a.cantidad, 0)}</td>
      <td></td>
      <td>
        {
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(totalHabilitacion)
        }
      </td>
    </tr>


    {/* Porcentaje representado */}
    <tr className="negrita">
      <td colSpan={2} className="text-end fw-bold">
        {porcentajeGlobal.toFixed(2)}% representa:
      </td>
  <td className="text-end">
  <Label htmlFor="aplicarPago" className="ms-2">
    Aplicar
    <span style={{ marginLeft: "10px" }}>
      <Input
        type="checkbox"
        id="aplicarPago"
        checked={aplicarPago}
        disabled={!(saldoHabilitacionCorte > 0.005)}
        onChange={(e) => setAplicarPago(e.target.checked)}
      />
    </span>
  </Label>
  {!(saldoHabilitacionCorte > 0.005) && (
    <div style={{ fontSize: "12px", fontWeight: "normal" }}>
      Material ya descontado
    </div>
  )}
</td>
      <td className="fw-bold">
        {
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(
            totalHabilitacion * (porcentajeGlobal / 100)
          )
        }
      </td>
    </tr>

     <tr className="negrita">
      <td colSpan={3} className="text-end fw-bold">
        Saldo Habilitacion:
      </td>
      <td className="fw-bold">
        {
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(saldoHabilitacionCorte)
        }
      </td>
    </tr>
  </tbody>
</Table>


                        
                            <br />
                    {validaBoton ? (
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={saveEntradaProceso}
                      >
                        Guardar
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        className="btn btn-success"
                        disabled
                      >
                        Guardar
                      </Button>
                    )}
                  </Col>
                </Row>
                {/* Termina Tabla Articulos */}
              </div>
            </div>
          </div>
        </div>
      ) : undefined}

      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>Progreso</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {" "}
            Este proceso puede tardar varios minutos.
            <br />
            Por favor no cierre ni refresque su navegador.
          </h4>
          <br />
          <div className="progreso">
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
            <Spinner
              style={{
                width: "50px",
                height: "50px",
                color: "#232B41",
              }}
            />
          </div>
        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default EntradaProcesosCreate;
